export default {
    id: 'requirements__placeholder',
    template: '',
};
